//i18n-setup.js
import { nextTick } from 'vue'
import { createI18n } from 'vue-i18n'
import Cookie from 'vue-cookie'
import store from '@/store/index'
import axios from '@/axios'

const loadedLocales = [];

export const i18n = createI18n({
	globalInjection: true,
	locale: store.state.activeLang,
	fallbackLocale: 'en',
	availableLocale: store.state.availableLocales
})

export function setI18nLanguage(i18n, locale) {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale.lang
  } else {
    i18n.global.locale.value = locale.lang
  }
	axios.defaults.headers.common['Accept-Language'] = locale.lang
  document.querySelector('html').setAttribute('lang', locale.lang)
	Cookie.set('locale', locale.lang, 1)
	store.actions.setActiveLang(locale.lang);

	//check if locale is already loaded
	if (!loadedLocales.includes(locale.lang)) {
		store.actions.toggleLoading(true);
		loadLocaleMessages(i18n, locale);
	}


}

export async function loadLocaleMessages(i18n, locale) {
  // load locale messages with dynamic import
  const messages = await axios.get('custom-content-page/'+locale.id+'/?_fields=id,slug,lang,acf_fields')
	.then((response) => {
		return response.data.acf_fields;
	}).catch((error) => {
		console.log(error);
	});
	
console.log('message', messages);
  // set locale and locale message
  i18n.global.setLocaleMessage(locale.lang, messages)
	store.actions.toggleLoading(false);

  return nextTick()
}